var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoStatusDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57831 5.21353L0.281143 1.82966C-0.102848 1.51875 -0.0919683 0.984075 0.304426 0.685366C0.640883 0.431823 1.14067 0.439183 1.46722 0.702488L4.5 3.86221L7.53278 0.702487C7.85933 0.439183 8.35912 0.431823 8.69557 0.685366C9.09197 0.984075 9.10285 1.51875 8.71886 1.82966L5.42169 5.21353C5.42169 5.21353 5.04475 5.5 4.5 5.5C3.95525 5.5 3.57831 5.21353 3.57831 5.21353Z",
    fill: "#011FBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoStatusDropdown);
export default __webpack_public_path__ + "static/media/po_status_dropdown.8778c2c683a7f26205a2c6c7b3865359.svg";
export { ForwardRef as ReactComponent };